import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M8.57 18.86H12l-.86-.86s.86-.86.86-1.71l-1.75.44a2.569 2.569 0 0 0-2.53-2.15 2.57 2.57 0 0 0-2.57 2.57c0 .66.26 1.26.67 1.72-4.95 0-5.81 5.14-5.81 5.14h9.43c.95 0 1.71-.77 1.71-1.71 0-1.71-2.57-3.43-2.57-3.43l-.01-.01ZM22.25 16.72a2.569 2.569 0 0 0-2.53-2.15 2.57 2.57 0 0 0-2.57 2.57c0 .66.26 1.26.67 1.72-4.95 0-5.81 5.14-5.81 5.14h9.43c.95 0 1.71-.77 1.71-1.71 0-1.71-2.57-3.43-2.57-3.43h3.43l-.86-.86s.86-.86.86-1.71l-1.75.44-.01-.01ZM17.14 5.14h5.95c.5 0 .91-.41.91-.91s-.38-.8-.86-.8c-3 0-4.29-3.43-6.86-3.43-3.43 0-5.14 4.71-1.71 7.29C11.14 4.72 4.28 5.15 0 5.15v5.14c0 1.71 0 4.29 2.57 4.29 2.14 0 2.57-2.57 5.14-2.57s3.43 2.57 6 2.57 3.43-2.57 6-2.57c1.71 0 2.57 2.14 3.43 2.14.86 0 .86-1.29.86-1.29 0-4.29-6.86-7.71-6.86-7.71v-.01Z" />
  </>
);

const CollKidFriendly = Icon('coll-kid-friendly', svgContents);

export default CollKidFriendly;
